import React, { useState } from "react";
import { CircularProgress } from "@mui/material";
import Swal from "sweetalert2";
import DynamicForm from "../../../../data/Axios/DynamicForm";
import { HRService } from "../../../../config";
import { generateAndExecuteMutation } from "../../../../data/Axios/DynamicService";

const base_url = HRService.uri;

const RelationshipTypeForm = (props) => {
  const [loading, setLoading] = useState(false);

  const initialValues = {
    relationshipName: props.data ? props.data.relationshipName : "",
  };

  const fields = [
    {
      name: "relationshipName",
      label: "Relationship Name",
      type: "text",
      gridColumn: "span 2",
      required: true,
    },
  ];

  const handleSubmit = async (values, { setSubmitting }) => {
    try {
      const { relationshipName } = values;

      const mutationData = {
        id: props.data?.id || null,
        relationshipName,
        createdBy: null,
        createdDate: null,
        updatedBy: null,
        updatedDate: null,
      };

      const mutationName = props.data
        ? "updateRelationshipType"
        : "createRelationshipType";

      const response = await generateAndExecuteMutation(
        mutationName,
        mutationData,
        "relationshipType",
        base_url
      );

      if (Object.values(response)[0] != null) {
        props.onClose();
        props.onAction();
        Swal.fire({
          icon: "success",
          title: "Success!",
          text: `Relationship Type ${
            props.data ? "updated" : "created"
          } successfully.`,
        });
      }
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Error!",
        text: "An error occurred while processing your request. Please try again later.",
      });
    }

    setSubmitting(false);
  };

  return loading ? (
    <CircularProgress />
  ) : (
    <DynamicForm
      initialValues={initialValues}
      fields={fields}
      onSubmit={handleSubmit}
      title={`${props.data ? "Update" : "Create"} Relationship Type`}
      subtitle={`Fill out the form below to ${
        props.data ? "update" : "create"
      } the relationship type.`}
    />
  );
};

export default RelationshipTypeForm;